import React, { useEffect, useState } from "react";
import { IoCheckmarkCircle } from "react-icons/io5";

const WelcomePage = () => {
  const [greeting, setGreeting] = useState("");
  const [name, setName] = useState("");

  useEffect(() => {
    const staffName = localStorage.getItem("name") || "User";
    setName(staffName.charAt(0).toUpperCase() + staffName.slice(1));

    const hour = new Date().getHours();
    if (hour < 12) setGreeting("Good morning");
    else if (hour < 17) setGreeting("Good afternoon");
    else setGreeting("Good evening");
  }, []);

  return (
    <div className="card px-4 py-5 bg-gradient-to-r from-primary-fixed/20 to-surface-lowest border-primary-fixed/30">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-xl sm:text-3xl font-bold text-on-primary-fixed-var">
            {greeting}, {name}.
          </h1>
          <p className="text-sm text-on-primary-fixed-var/70 mt-1 max-w-lg">
            Here is a summary of your health benefits and upcoming tasks.
          </p>
        </div>
        <div className="flex items-center gap-1.5 bg-primary-container text-white text-xs font-semibold px-3 py-2 rounded-full shrink-0 self-start sm:self-center max-w-full">
          <IoCheckmarkCircle size={16} />
          Corporate Pass Active
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
